var _circle, _path, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataSold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E5B909",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 25.4026C10.875 23.2914 10.875 22.2357 11.167 21.3856C11.7063 19.8151 12.9401 18.5813 14.5106 18.042C15.3607 17.75 16.4164 17.75 18.5276 17.75H19.625C21.3176 17.75 22.1638 17.75 22.8663 17.8971C25.5596 18.4611 27.6639 20.5654 28.2279 23.2587C28.375 23.9612 28.375 24.8074 28.375 26.5C28.375 28.1926 28.375 29.0388 28.2279 29.7413C27.6639 32.4346 25.5596 34.5389 22.8663 35.1029C22.1638 35.25 21.3176 35.25 19.625 35.25C17.9324 35.25 17.0862 35.25 16.3837 35.1029C13.6904 34.5389 11.5861 32.4346 11.0221 29.7413C10.875 29.0388 10.875 28.1926 10.875 26.5V25.4026Z",
    fill: "#E5B910"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.8574,
    cy: 24.4863,
    r: 2.4746,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M29.1366 19.4555C29.2643 19.6864 29.4648 19.871 29.7017 19.9732C29.8658 20.0385 30.3582 20.1398 30.3666 20.1398C30.9047 20.242 31.7794 20.2969 32.7456 20.2969C33.666 20.2969 34.5043 20.242 35.0508 20.1587C35.0601 20.1492 35.67 20.047 35.8799 19.9363C36.2631 19.7328 36.5 19.3353 36.5 18.9094V18.8725C36.4907 18.5952 36.2538 18.0131 36.2445 18.0131C35.8435 17.0326 34.5957 15.099 33.7658 14.3229C33.7658 14.3229 33.5522 14.1033 33.4198 14.0087C33.2286 13.8601 32.9917 13.7863 32.7539 13.7863C32.49 13.7863 32.2448 13.8696 32.0433 14.0267C32.007 14.0636 31.8522 14.2027 31.7244 14.3314C30.9233 15.0905 29.6103 17.0695 29.2103 18.1049C29.1459 18.262 29.0088 18.6605 29.0004 18.8725C29.0004 19.076 29.0452 19.2709 29.1366 19.4555Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSold);
export default __webpack_public_path__ + "static/media/data-sold.fdfc599b90c90e8f6969623d1568e7c5.svg";
export { ForwardRef as ReactComponent };